import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';
export const issueLogApi = createApi({
  baseQuery,
  reducerPath: 'issueLogApi',
  endpoints: builder => ({
    getStudyLog: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(endPoints.conductStudyLog.getAll)}?application_module_section=${`STUDY LOGS`}${
          study_id !== null ? `&study_id=${study_id}` : ''
        }${country !== null ? `&country=${country}` : ''}${site_id !== null ? `&site_id=${site_id}` : ''}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getIssueLog: builder.query<any, any>({
      query: ({ site_id, study_id, country, issue_level, application, from = -1, size = -1, data }) => ({
        url: formatString(
          `${
            endPoints.conductIssueLog.getAll
          }?application=${application}&application_section=CONDUCT&issue_level=${issue_level}${
            study_id !== null ? `&study_id=${study_id}` : ''
          }${country !== null ? `&country=${country}` : ''}${site_id !== null ? `&site_id=${site_id}` : ''}${
            from > -1 ? `&from=${from}` : ''
          }${size > -1 ? `&size=${size}` : ''}`
        ),
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getStudyInfo: builder.query<any, any>({
      query: ({ study_id, application }) => ({
        url: formatString(`${endPoints.study.studyInfo}/${study_id}/select?application=${application}`),
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createIssueLog: builder.mutation<any, any>({
      query: ({ data, study_id, country, site_id }) => ({
        url: `${formatString(endPoints.conductIssueLog.create, {
          key: urlKeys.study_id,
          value: study_id !== null ? study_id : null
        })}?${country !== null ? `country=${country}` : ''}${
          site_id !== null ? `&site_id=${site_id}` : ''
        }&application=${data.application}&application_section=CONDUCT&application_module_section=${`ISSUE LOG`}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateIssueLog: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.conductIssueLog.put, { key: 'issue_id', value: data.id })}?study_id=${
          data.study_id
        }&country=${data.country}&site_id=${
          data.site_id
        }&application=CTMS&application_section=CONDUCT&application_module_section=${`ISSUE LOG`}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateAllIssueLog: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.conductIssueLog.updateAll, { key: 'issue_id', value: data.id })}?study_id=${
          data.study_id
        }&country=${data.country}&site_id=${
          data.site_id
        }&application=CTMS&application_section=CONDUCT&application_module_section=${`ISSUE LOG`}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateIssueAction: builder.mutation<any, any>({
      query: ({ issue_id, data, study_id, country, site_id, application, issue_level }) => ({
        url: `${formatString(endPoints.conductIssueLog.updateIssueAction, {
          key: urlKeys.issue_id,
          value: issue_id
        })}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&issue_level=${issue_level}&application=${application}&application_section=CONDUCT`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    delete: builder.mutation<any, any>({
      query: ({ data, study_id, country, site_id, application, issue_level }) => ({
        url: `${formatString(endPoints.conductIssueLog.delete, { key: 'issue_id', value: data.id })}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&issue_level=${issue_level}&application=${application}&application_section=CONDUCT`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    deleteAll: builder.mutation<any, any>({
      query: ({ data, study_id, country, site_id, application, issue_level }) => ({
        url: `${formatString(endPoints.conductIssueLog.deleteAll, { key: 'issue_id', value: data.id })}?${
          study_id !== null ? `study_id=${study_id}` : ''
        }&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&issue_level=${issue_level}&application=${application}&application_section=CONDUCT`,
        method: 'DELETE'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateIssueDecision: builder.mutation<any, any>({
      query: ({ issue_id, site_id, study_id, country, data, application, issue_level }) => ({
        url: `${formatString(endPoints.conductIssueLog.updateIssueDecision, {
          key: urlKeys.issue_id,
          value: encodeURIComponent(issue_id)
        })}?${study_id !== null ? `study_id=${study_id}` : ''}&${country !== null ? `country=${country}` : ''}&${
          site_id !== null ? `site_id=${site_id}` : ''
        }&issue_level=${issue_level}&application=${application}&application_section=CONDUCT&application_module_section=${`${`ISSUE LOG`}`}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    copyToSponsor: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.conductIssueLog.copyToSponsor,
          {
            key: urlKeys.study_id,
            value: encodeURIComponent(study_id)
          },
          {
            key: urlKeys.site_id,
            value: encodeURIComponent(site_id)
          }
        )}?${
          country !== null ? `country=${country}` : ''
        }&application=${application}&application_section=CONDUCT&application_module_section=${`${`ISSUE LOG`}`}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getIssueLogBasedOnDateRange: builder.query<any, any>({
      query: ({ site_id, study_id, country, issue_level, application, start_date, end_date, data }) => ({
        url: formatString(
          `${
            endPoints.conductIssueLog.getAll
          }?application=${application}&application_section=CONDUCT&issue_level=${issue_level}${
            study_id !== null ? `&study_id=${study_id}` : ''
          }${country !== null ? `&country=${country}` : ''}${
            site_id !== null ? `&site_id=${site_id}` : ''
          }&start_date=${start_date}&end_date=${end_date}`
        ),
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});
export const {
  useLazyGetStudyLogQuery,
  useLazyGetIssueLogQuery,
  useGetStudyInfoQuery,
  useCreateIssueLogMutation,
  useUpdateIssueLogMutation,
  useUpdateIssueActionMutation,
  useUpdateIssueDecisionMutation,
  useDeleteMutation,
  useDeleteAllMutation,
  useUpdateAllIssueLogMutation,
  useCopyToSponsorMutation,
  useLazyGetIssueLogBasedOnDateRangeQuery
} = issueLogApi;
